import { highlightRect } from "../../../lib/utils/browser/highlightRect";
import { INJECT_UICORE_BUS, INJECT_UICORE_DESIGNER } from "../../../lib/utils/consts";
import { VNodes, vueLinkSessionStorage } from "../../../lib/utils/vue";
import ComponentListWithCatalogue from '../ComponentListWithCatalogue';
import DataSourceTree from '../DataSourceTree';
import DSTreeNode from '../DataSourceTree/DSTreeNode';
import DSActionsRenderer from '../DataSourceTree/DSActionsRenderer';
import makeSchmittTrigger from "../../../lib/utils/makeSchmittTrigger";
import DEFAULT_COMPONENT_ICON from '../../assets/defaultComponentIcon.png';
import ComponentButton from "./ComponentButton";
import MockButton from "./MockButton";
import MaterialBoxTabTitle from './material-box-tab-title';
// 左侧的物料库
const __script_base__ = {
  name: 'MaterialBox',
  inject: {
    uc: {
      from: INJECT_UICORE_BUS,
      default: null
    },
    designer: {
      from: INJECT_UICORE_DESIGNER,
      default: null
    }
  },
  components: {
    ComponentListWithCatalogue,
    DataSourceTree,
    DSTreeNode,
    DSActionsRenderer,
    VNodes,
    ComponentButton,
    MockButton,
    MaterialBoxTabTitle
  },
  provide() {
    return {
      MaterialBox: this
    };
  },
  data() {
    return {
      defaultIcon: DEFAULT_COMPONENT_ICON,
      activeKey: 'data',
      // 包装成对象方便作用域插槽响应式回填value
      materialBoxFilterKeyGlobal: {
        value: ''
      },
      // 不要用这个变量，请使用 computed 里面的 currentHoveringDataPath
      internalCurrentHoveringDataPath: '',
      // 不要用这个变量，请使用 computed 里面的 currentHoveringComp
      internalCurrentHoveringComp: null,
      renderTemplate: false,
      helperUrl: ''
    };
  },
  computed: {
    tabs() {
      const {
        materialBoxFilter,
        customMaterialBoxes
      } = this.uc.config.designerUiConfig;
      const customTab = customMaterialBoxes.filter(item => this.designer.$scopedSlots[item.id]);
      return [this.designer.$scopedSlots.templatePanel ? {
        id: 'template_panel',
        title: '模板'
      } : null, {
        id: 'common',
        title: '通用组件'
      }, {
        id: 'data',
        title: '数据源'
      }, ...customTab].filter(Boolean).filter(materialBoxFilter);
    },
    currentHoveringDataPath: makeSchmittTrigger('internalCurrentHoveringDataPath', 300),
    currentHoveringComp: makeSchmittTrigger('internalCurrentHoveringComp', 300),
    allMaterialItems() {
      const ans = [];
      const groupedAns = this.designer.getMaterialBoxGroups({
        filter: component => {
          if (!component.visible) return false;
          if (component.type !== 'normal') return false;
          return true;
        }
      });
      groupedAns.forEach(group => {
        var _group$items;
        (_group$items = group.items) === null || _group$items === void 0 || _group$items.forEach(item => {
          ans.push({
            ...item,
            category: group.name
          });
        });
      });
      return ans;
    },
    dataStub() {
      return this.designer.currentDesignScope.getDataStub();
    },
    templates() {
      var _this$designer;
      return (_this$designer = this.designer) === null || _this$designer === void 0 ? void 0 : _this$designer.templates;
    },
    isShowTemplate() {
      var _this$designer2;
      return (_this$designer2 = this.designer) === null || _this$designer2 === void 0 || (_this$designer2 = _this$designer2.templateConfig) === null || _this$designer2 === void 0 ? void 0 : _this$designer2.isShowTemplate;
    },
    customScopedSlots() {
      return this.uc.config.designerUiConfig.customMaterialBoxes.map(item => item.id);
    }
  },
  created() {
    // 从localstorage加载/保存tab栏信息 来保证切换预览前后选项一致
    vueLinkSessionStorage(this, 'MaterialBox', 'activeKey');
    this.$watch(() => this.activeKey, val => {
      if (val === 'template_panel') {
        // 懒加载 避免dom高度检测失误
        this.renderTemplate = true;
      }
      this.resetFilterKey();
      // 加入ui修剪后 localstorage里可能会出现不存在的tab key
      this.validActiveKey();
    }, {
      immediate: true
    });
    this.$watch('tabs', this.validActiveKey);
    const HELP_URL_KEY = 'devComponent';
    this.helperUrl = this.uc.config.docEnable ? this.uc.config.docLink[HELP_URL_KEY] : '';
  },
  methods: {
    validActiveKey() {
      const validKey = this.tabs.some(item => item.id === this.activeKey);
      if (this.tabs.length > 0 && !validKey) {
        var _this$tabs$;
        this.activeKey = (_this$tabs$ = this.tabs[0]) === null || _this$tabs$ === void 0 ? void 0 : _this$tabs$.id;
      }
    },
    clearSearchKey() {
      this.materialBoxFilterKeyGlobal.value = '';
    },
    resetFilterKey() {
      if (this.designer.skeletonStyle.clearSearchInputWhenSwitchLeftPanel) {
        this.materialBoxFilterKeyGlobal.value = '';
      }
    },
    matchMaterialItem(key, item) {
      var _item$category, _item$name, _item$layout, _item$keywords;
      const k = key.toLowerCase();
      return ((_item$category = item.category) === null || _item$category === void 0 ? void 0 : _item$category.toLowerCase().includes(k)) || ((_item$name = item.name) === null || _item$name === void 0 ? void 0 : _item$name.toLowerCase().includes(k)) || ((_item$layout = item.layout) === null || _item$layout === void 0 || (_item$layout = _item$layout.type) === null || _item$layout === void 0 ? void 0 : _item$layout.toLowerCase().includes(k)) || ((_item$keywords = item.keywords) === null || _item$keywords === void 0 ? void 0 : _item$keywords.some(keyword => keyword === null || keyword === void 0 ? void 0 : keyword.toLowerCase().includes(k)));
    },
    handleStubClick(instance) {
      const compPaths = Object.keys(this.designer.getRelatedCompPathsOfDataPath(instance.dataPath));
      if (!compPaths) return;
      compPaths.forEach(compPath => {
        try {
          const el = this.designer.renderer.getRefByPath(compPath).$el;
          highlightRect(el.getBoundingClientRect());
        } catch (e) {}
      });
    },
    getDSTreeFieldHidden(schema) {
      return !!(schema !== null && schema !== void 0 && schema['uc:hiddenInDSTree']);
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.tabs.length > 0 ? _c("div", {
    staticClass: "ucd-materialBox"
  }, [_c("div", {
    staticClass: "ucd-materialBox-header"
  }, [_c("div", {
    staticClass: "uc-tabs-list nowrap isDark withShortIndicator"
  }, _vm._l(_vm.tabs, function (tab) {
    return _c("div", {
      key: tab.id,
      staticClass: "uc-tabs-item",
      class: {
        isActive: tab.id === _vm.activeKey
      },
      attrs: {
        tabindex: "0",
        "data-ucd-report-eid": "选项卡:" + tab.title,
        "data-ucd-report-submods": "submod1=" + tab.title
      },
      on: {
        click: function ($event) {
          _vm.activeKey = tab.id;
        }
      }
    }, [_c("MaterialBoxTabTitle", {
      attrs: {
        title: tab.title,
        id: tab.id
      }
    })], 1);
  }), 0)]), _vm._v(" "), _c("div", {
    staticClass: "ucd-materialBox-header"
  }, [["common"].includes(_vm.activeKey) ? _c("div", {
    staticClass: "ucd-materialBox-withExtra"
  }, [_c("a-input", {
    staticClass: "ucd-materialBox-filterKey ucd-asidePane-searchInput",
    attrs: {
      type: "text",
      placeholder: "输入组件名字或ID",
      spellcheck: "false",
      "allow-clear": true
    },
    on: {
      keydown: function ($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) {
          return null;
        }
        return _vm.clearSearchKey.apply(null, arguments);
      }
    },
    model: {
      value: _vm.materialBoxFilterKeyGlobal.value,
      callback: function ($$v) {
        _vm.$set(_vm.materialBoxFilterKeyGlobal, "value", $$v);
      },
      expression: "materialBoxFilterKeyGlobal.value"
    }
  }, [!_vm.materialBoxFilterKeyGlobal.value ? _c("a-icon", {
    staticClass: "ucd-asidePane-searchInput-suffix",
    attrs: {
      slot: "suffix",
      type: "search"
    },
    slot: "suffix"
  }) : _vm._e()], 1), _vm._v(" "), _vm.designer.$scopedSlots.componentSearchBarSuffix ? _c("VNodes", {
    attrs: {
      vnodes: _vm.designer.$scopedSlots.componentSearchBarSuffix({
        designer: _vm.designer,
        uc: _vm.uc
      })
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm.activeKey === "data" ? _c("div", {
    staticClass: "ucd-materialBox-withExtra"
  }, [_c("a-input", {
    staticClass: "ucd-materialBox-filterKey ucd-asidePane-searchInput",
    attrs: {
      type: "text",
      placeholder: "输入字段名或ID",
      spellcheck: "false",
      "allow-clear": true
    },
    on: {
      keydown: function ($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) {
          return null;
        }
        return _vm.clearSearchKey.apply(null, arguments);
      }
    },
    model: {
      value: _vm.materialBoxFilterKeyGlobal.value,
      callback: function ($$v) {
        _vm.$set(_vm.materialBoxFilterKeyGlobal, "value", $$v);
      },
      expression: "materialBoxFilterKeyGlobal.value"
    }
  }, [!_vm.materialBoxFilterKeyGlobal.value ? _c("a-icon", {
    staticClass: "ucd-asidePane-searchInput-suffix",
    attrs: {
      slot: "suffix",
      type: "search"
    },
    slot: "suffix"
  }) : _vm._e()], 1), _vm._v(" "), _vm.designer.$scopedSlots.dataSourceSearchBarSuffix ? _c("VNodes", {
    attrs: {
      vnodes: _vm.designer.$scopedSlots.dataSourceSearchBarSuffix({
        designer: _vm.designer,
        uc: _vm.uc
      })
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm.designer.$scopedSlots.materialBoxHeader ? _c("VNodes", {
    attrs: {
      vnodes: _vm.designer.$scopedSlots.materialBoxHeader({
        context: this,
        designer: _vm.designer,
        uc: _vm.uc
      })
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm.designer.$scopedSlots.templatePanel && _vm.activeKey === "template_panel" ? _c("VNodes", {
    attrs: {
      vnodes: _vm.designer.$scopedSlots.templatePanel({
        context: this,
        designer: _vm.designer,
        uc: _vm.uc,
        materialBoxFilterKeyGlobal: _vm.materialBoxFilterKeyGlobal
      })
    }
  }) : _vm._e(), _vm._v(" "), _vm._l(_vm.customScopedSlots, function (slotKey) {
    return [_vm.designer.$scopedSlots[slotKey] && _vm.activeKey === slotKey ? _c("VNodes", {
      key: slotKey,
      attrs: {
        vnodes: _vm.designer.$scopedSlots[slotKey]({
          context: this,
          designer: _vm.designer,
          uc: _vm.uc
        })
      }
    }) : _vm._e()];
  }), _vm._v(" "), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeKey === "common",
      expression: "activeKey === 'common'"
    }],
    staticClass: "ucd-materialBox-content"
  }, [_c("ComponentListWithCatalogue", {
    attrs: {
      data: _vm.allMaterialItems,
      "category-key": "category",
      "filter-key": _vm.materialBoxFilterKeyGlobal.value,
      "filter-function": _vm.matchMaterialItem
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (ref) {
        var item = ref.item;
        return [_c("ComponentButton", {
          attrs: {
            item: item
          }
        })];
      }
    }], null, false, 2144392855)
  })], 1), _vm._v(" "), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeKey === "data",
      expression: "activeKey === 'data'"
    }],
    staticClass: "ucd-materialBox-content"
  }, [_c("DataSourceTree", {
    attrs: {
      "show-actions": "",
      "search-keyword": _vm.materialBoxFilterKeyGlobal.value,
      "show-array-items-tree": true
    },
    scopedSlots: _vm._u([{
      key: "before-children",
      fn: function (ref) {
        var actions = ref.actions;
        return [_c("DSActionsRenderer", {
          staticClass: "ucd-dataTreeActions",
          attrs: {
            actions: actions,
            position: "before-children"
          }
        })];
      }
    }, {
      key: "after-children",
      fn: function (ref) {
        var actions = ref.actions;
        return [_c("DSActionsRenderer", {
          staticClass: "ucd-dataTreeActions",
          attrs: {
            actions: actions,
            position: "after-children"
          }
        })];
      }
    }, {
      key: "node",
      fn: function (ref) {
        var name = ref.name;
        var stub = ref.stub;
        var dataPath = ref.dataPath;
        var depth = ref.depth;
        var expandable = ref.expandable;
        var expanded = ref.expanded;
        var actions = ref.actions;
        var toggleExpansion = ref.toggleExpansion;
        var id = ref.id;
        return [_c("DSTreeNode", {
          key: "dsnode:" + dataPath,
          attrs: {
            name: name,
            stub: stub,
            "data-path": dataPath,
            depth: depth,
            expandable: expandable,
            expanded: expanded,
            "toggle-expansion": toggleExpansion,
            "line-expansion": true,
            "show-object-value": true,
            draggable: true,
            id: id
          },
          on: {
            click: _vm.handleStubClick
          }
        }, [_c("DSActionsRenderer", {
          staticClass: "ucd-dataTreeNode-actions",
          attrs: {
            slot: "after",
            actions: actions,
            position: "after"
          },
          slot: "after"
        })], 1)];
      }
    }], null, false, 2059223356)
  })], 1)], 2) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "comps/MaterialBox/index.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);